export default function Footer() {
  return (
    <footer id="access" className="bg-[#f2ede3] py-16">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-12">
          <div>
            <p className="font-serif text-2xl text-[#3a4a28] tracking-[0.2em] mb-4">KUU</p>
            <p className="text-[#6a6a5a] text-sm leading-loose tracking-wide">
              鎌倉・二階堂、永福寺跡を見渡す隠れ家サロン。<br />
              身体を整え、動ける状態へ。
            </p>
          </div>
          <div>
            <h4 className="text-xs text-[#3a4a28] tracking-[0.3em] mb-5">ACCESS</h4>
            <address className="not-italic space-y-2">
              <p className="text-[#5a5a4a] text-sm tracking-wide">〒248-0002</p>
              <p className="text-[#5a5a4a] text-sm tracking-wide">神奈川県鎌倉市二階堂209</p>
              <p className="text-[#5a5a4a] text-sm tracking-wide mt-4">JR鎌倉駅より徒歩30分</p>
              <p className="text-[#5a5a4a] text-sm tracking-wide">バスで大塔宮駅まで10分、+徒歩10分</p>
            </address>
          </div>
          <div>
            <h4 className="text-xs text-[#3a4a28] tracking-[0.3em] mb-5">HOURS</h4>
            <div className="space-y-2">
              {[
                { day: "月・水・木・金", time: "10:00〜19:00" },
                { day: "土・日・祝", time: "9:00〜18:00" },
                { day: "火曜日", time: "定休日" },
              ].map((h, i) => (
                <div key={i} className="flex gap-4 text-sm text-[#5a5a4a] tracking-wide">
                  <span className="w-28 flex-shrink-0">{h.day}</span>
                  <span>{h.time}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/kuuseitai0528/" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center text-[#3a4a28] hover:text-[#5a7040] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center text-[#3a4a28] hover:text-[#5a7040] transition-colors cursor-pointer">
                <i className="ri-line-line text-xl" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-[#ddd9cf] pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#9a9a8a] text-xs tracking-wide">© 2024 KUU. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="text-[#9a9a8a] text-xs tracking-wide hover:text-[#3a4a28] transition-colors cursor-pointer">プライバシーポリシー</a>
            <a href="#" className="text-[#9a9a8a] text-xs tracking-wide hover:text-[#3a4a28] transition-colors cursor-pointer">特定商取引法に基づく表記</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
